import { useArticleListQuery } from "entities/manageArticles/queries/useArticleListQuery";
import {
  Article,
  ArticleBrandId,
  ArticleCategory,
} from "entities/manageArticles/types";
import { FC } from "react";
import { generatePath, Outlet, useNavigate, useParams } from "react-router-dom";
import TableWithPagination from "shared/components/TableWithPagination";
import { MANAGE_ARTICLES_GROUP_PATH } from "shared/routes/paths";
import ManageArticlesLayout from "./components/ManageArticlesLayout";
import { getArticlesColumns } from "./helpers";

const ManageArticles: FC = () => {
  const {
    brandId = ArticleBrandId.INTERNATIONAL,
    categoryId = ArticleCategory.LEGAL,
  } = useParams();
  const navigate = useNavigate();

  const { data = [], isLoading } = useArticleListQuery({
    brandId: brandId as ArticleBrandId,
    categoryId: categoryId as ArticleCategory,
  });

  const columns = getArticlesColumns(
    brandId as ArticleBrandId,
    categoryId as ArticleCategory,
    navigate,
  );

  return (
    <ManageArticlesLayout>
      <TableWithPagination<Article>
        data={data}
        columns={columns}
        loading={isLoading}
        emptyStateMessage="No articles found"
        sortingMode="client"
        heightTable={"78vh"}
        hideFooter
        onRowClick={(params) =>
          navigate(
            generatePath(MANAGE_ARTICLES_GROUP_PATH, {
              brandId,
              categoryId,
              groupId: params.row.id,
            }),
          )
        }
      />
      <Outlet />
    </ManageArticlesLayout>
  );
};

export default ManageArticles;
